<template>
  <el-dialog :title="$t('editOrg.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form :model="editOrgInfo" :rules="rules" ref="editOrgForm" label-width="120px">
      <el-form-item :label="$t('editOrg.orgName')" prop="orgName">
        <el-input v-model="editOrgInfo.orgName" :placeholder="$t('editOrg.orgNamePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('editOrg.parentOrg')" prop="parentOrgName">
        <el-input v-model="editOrgInfo.parentOrgName" disabled
          :placeholder="$t('editOrg.parentOrgPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('editOrg.description')" prop="description">
        <el-input type="textarea" :rows="3" :placeholder="$t('editOrg.descriptionPlaceholder')"
          v-model="editOrgInfo.description"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editOrg">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateOrg, listOrgs } from '@/api/frame/orgApi'

export default {
  name: 'EditOrg',
  data() {
    return {
      dialogVisible: false,
      editOrgInfo: {
        orgId: '',
        orgName: '',
        orgLevel: '',
        parentOrgId: '',
        parentOrgName: '',
        description: '',
        belongCommunityId: ''
      },
      rules: {
        orgName: [
          { required: true, message: this.$t('editOrg.orgNameRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('editOrg.orgNameLength'), trigger: 'blur' }
        ],
        parentOrgId: [
          { required: true, message: this.$t('editOrg.parentOrgRequired'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('editOrg.descriptionLength'), trigger: 'blur' }
        ],
        orgId: [
          { required: true, message: this.$t('editOrg.orgIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.resetForm()
        if (params) {
          Object.assign(this.editOrgInfo, params)
          this.editOrgInfo.parentOrgId = params.parentId
          this._listEditOrgs()
        }
      })
    },
    editOrg() {
      this.$refs.editOrgForm.validate(valid => {
        if (!valid) return

        updateOrg(this.editOrgInfo).then(response => {
          this.$message.success(this.$t('editOrg.saveSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        }).catch(error => {
          this.$message.error(error.message)
        })
      })
    },
    _listEditOrgs() {
      const params = {
        page: 1,
        row: 1,
        orgId: this.editOrgInfo.orgId
      }

      listOrgs(params).then(response => {
        if (response.data && response.data.length > 0) {
          Object.assign(this.editOrgInfo, response.data[0])
        }
      })
    },
    _editOrgListParentOrgInfo() {
      console.log('_editOrgListParentOrgInfo')
    },
    resetForm() {
      this.$refs.editOrgForm && this.$refs.editOrgForm.resetFields()
      this.editOrgInfo = {
        orgId: '',
        orgName: '',
        orgLevel: '',
        parentOrgId: '',
        parentOrgName: '',
        description: '',
        belongCommunityId: ''
      }
    },
    handleClose() {
      this.resetForm()
    }
  }
}
</script>